import { MemberPaymentMethodFragment, MemberPaymentProvider } from '@/services/graphql/generated'
import { BankPaymentMethod, InvoicePaymentMethod, SwishPaymentMethod, TrustlyPaymentMethod } from './payments.types'

export function isBankPaymentMethod(method: MemberPaymentMethodFragment): method is BankPaymentMethod {
  return method.provider === MemberPaymentProvider.Nordea
}

export function isInvoicePaymentMethod(method: MemberPaymentMethodFragment): method is InvoicePaymentMethod {
  return method.provider === MemberPaymentProvider.Invoice
}

export function isSwishPaymentMethod(method: MemberPaymentMethodFragment): method is SwishPaymentMethod {
  return method.provider === MemberPaymentProvider.Swish
}

export function isTrustlyPaymentMethod(method: MemberPaymentMethodFragment): method is TrustlyPaymentMethod {
  return method.provider === MemberPaymentProvider.Trustly
}

interface Defaultable {
  isDefault: boolean
}

// API quirk: a PENDING method can be considered the default but is absent from the defaultPayin/outMethod
// field. Fall back to the first method with isDefault=true to handle this edge case.
export function getDefaultPayinMethod<T extends Defaultable>({
  defaultPayinMethod,
  payinMethods,
}: {
  defaultPayinMethod?: T | null
  payinMethods: ReadonlyArray<T>
}) {
  return defaultPayinMethod ?? payinMethods.find(({ isDefault }) => isDefault)
}

export function getDefaultPayoutMethod<T extends Defaultable>({
  defaultPayoutMethod,
  payoutMethods,
}: {
  defaultPayoutMethod?: T | null
  payoutMethods: ReadonlyArray<T>
}) {
  return defaultPayoutMethod ?? payoutMethods.find(({ isDefault }) => isDefault)
}
